import React from "react";
import { SpinnerCircularFixed } from "../../../../assets/spinner/SpinnerCircularFixed";
import { NoImage as NoImageIcon } from "../../../../assets/NoImage";

interface ImageUploaderProps {
    fieldId: string;
    previewSrc?: string;
    isUploading: boolean;
    disabled?: boolean;
    placeholderText?: string;
    onUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onRemove: () => void;
    useBackgroundPreview?: boolean;
}

export const ImageUploader: React.FC<ImageUploaderProps> = ({
    fieldId,
    previewSrc,
    isUploading,
    disabled = false,
    placeholderText = "Upload Image",
    onUpload,
    onRemove,
    useBackgroundPreview = false,
}) => {
    const renderPreview = () => {
        if (isUploading) {
            return (
                <div className="spinner-div-img">
                    <SpinnerCircularFixed
                        size={25}
                        thickness={140}
                        speed={120}
                        color="rgb(145,145,145)"
                        secondaryColor="rgba(0,0,0,.44)"
                    />
                </div>
            );
        }

        if (previewSrc) {
            return useBackgroundPreview ? (
                <div style={{ backgroundImage: `url("${decodeURIComponent(previewSrc)}")` }} />
            ) : (
                <img
                    src={decodeURIComponent(previewSrc)}
                    alt={`${fieldId} preview`}
                    className="logoPreview__img"
                    draggable={false}
                />
            );
        }

        return (
            <div className="logoPlaceholder">
                <NoImageIcon />
                <span>{placeholderText}</span>
            </div>
        );
    };

    return (
        <>
            <div className="preview">
                {renderPreview()}
            </div>
            <div className="actions">
                <input
                    type="file"
                    id={fieldId}
                    accept=".png,.jpg,.jpeg"
                    onChange={onUpload}
                    disabled={disabled}
                />
                <div className="uploaderControl">
                    <label htmlFor={fieldId} className="btnUpload" aria-label="Upload">
                        <span className="icoUpload" aria-hidden="true" />
                    </label>
                    <label htmlFor={fieldId} className="uploadText">Upload</label>
                </div>
                <div className="uploaderControl">
                    <button
                        type="button"
                        className="btnRemove"
                        onClick={onRemove}
                        disabled={disabled}
                    >
                        <span className="icoTrash" />
                    </button>
                    <span>Remove</span>
                </div>
            </div>
        </>
    );
};